export default __webpack_public_path__ + "static/media/about.47b7c4db.svg";